import { render, staticRenderFns } from "./AffiliatedDoctors.vue?vue&type=template&id=7275e8d4&scoped=true"
import script from "./AffiliatedDoctors.vue?vue&type=script&lang=js"
export * from "./AffiliatedDoctors.vue?vue&type=script&lang=js"
import style0 from "./AffiliatedDoctors.vue?vue&type=style&index=0&id=7275e8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275e8d4",
  null
  
)

export default component.exports